import React from "react";
import Switch from "react-switch";

// One "Show all" switch for every list. Lists open showing active rows only;
// switching it on (red) adds the inactive ones. `hidden` is how many inactive
// rows are out of view, so people can see something is filtered.
const ShowAllToggle = ({ checked, onChange, prefix, hidden }) => (
  <div className="filter_active">
    {prefix ? <p>{prefix}</p> : null}
    {!checked && hidden > 0 ? <p style={{ color: "#6b7280" }}>{hidden} inactive hidden</p> : null}
    <p style={{ cursor: "pointer" }} onClick={() => onChange(!checked)}>
      Show all
    </p>
    <Switch
      checked={!!checked}
      onChange={(value) => onChange(value)}
      onColor="#A6192E"
      offColor="#9ca3af"
      handleDiameter={20}
      uncheckedIcon={false}
      checkedIcon={false}
      height={24}
      width={46}
      aria-label="Show all"
    />
  </div>
);

// Whether a list row is active. Pages pass status_data (1 or 0) where the
// shown status is a badge; otherwise a plain status value ("Active",
// "Inactive", 1, 0) is read. null when the row has neither, and a list where
// no row has a status doesn't show the switch at all.
export const rowActive = (row) => {
  const flag = row?.status_data;
  if (flag !== undefined && flag !== null && flag !== "") return Number(flag) === 1;
  const status = row?.status;
  if (typeof status === "number" || typeof status === "string") {
    const value = String(status).trim().toLowerCase();
    if (value === "1" || value === "active") return true;
    if (value === "0" || value === "inactive") return false;
  }
  return null;
};

export default ShowAllToggle;
